import React__default from 'react';
import { clamp } from '../../../utils/clamp.es.js';
import { useHeadingLevel, HeadingLevelProvider } from '../../../utils/heading-level-context/HeadingLevelContext.es.js';

const HeadingLevel = ({ children }) => {
  const { level } = useHeadingLevel();
  const nextLevel = clamp(level + 1, 1, 6);
  return React__default.createElement(HeadingLevelProvider, { level: nextLevel }, children);
};

export { HeadingLevel };
//# sourceMappingURL=HeadingLevel.es.js.map
